module.exports = __webpack_public_path__ + "static/media/thawing-island-18705.herokuapp.com-dashboard.fb8a7271.png";